var youbora = require('youboralib')
require('./adapter')
require('./analyticsFramework')(youbora)

module.exports = youbora



//////////////////
// WEBPACK FOOTER
// ./src/sp.js
// module id = 55
// module chunks = 0